import {
  WebhusetConstantsOrderAgreementPeriodTypeItemObject,
  type WebhusetConstantsOrderAgreementPeriodTypeItem,
} from "~/sdk/generated/models";

const humanAgreementPeriods: Record<
  WebhusetConstantsOrderAgreementPeriodTypeItem,
  string
> = {
  [WebhusetConstantsOrderAgreementPeriodTypeItemObject.Biennially]: "halvårlig",
  [WebhusetConstantsOrderAgreementPeriodTypeItemObject.Triennielly]: "treårig",
  [WebhusetConstantsOrderAgreementPeriodTypeItemObject.Yearly]: "årlig",
  [WebhusetConstantsOrderAgreementPeriodTypeItemObject.Quarterly]: "kvartalvis",
  [WebhusetConstantsOrderAgreementPeriodTypeItemObject.Monthly]: "månedlig",
};

export function getAgreementPeriodHumanText(
  agreementPeriod: WebhusetConstantsOrderAgreementPeriodTypeItem,
  capitalize: boolean = false
) {
  const humanText = humanAgreementPeriods[agreementPeriod];

  return capitalize
    ? humanText.charAt(0).toUpperCase() + humanText.slice(1)
    : humanText;
}
